/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	PublicDataRemovalRequestConfirmPathParams,
	PublicDataRemovalRequestConfirmResponse,
} from '../types/PublicDataRemovalRequestConfirm'

/**
 * POST /data-removal/:token/confirm
 * @see backend/nexus/modules/Campaign/Http/Controllers/PublicDataRemovalRequestController.php PublicDataRemovalRequestController::confirm
 */
export async function publicDataRemovalRequestConfirm(
	token: PublicDataRemovalRequestConfirmPathParams['token'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<PublicDataRemovalRequestConfirmResponse>> {
	return axiosInstance.post(`/data-removal/${token}/confirm`, undefined, config)
}
